module.exports = __webpack_public_path__ + "static/media/pennappsxxi_logo.db67b65c.jpg";